<template>
  <v-menu
    v-model="menu"
    :ref="eleRef"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    :nudge-right="40"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        slot="activator"
        :label="label"
        v-model="valueData"
        append-outer-icon="event"
        v-on="on"
        :hide-details="hideDetails"
        readonly
        :disabled="disabled"
        :error-messages="errorMessages"
      ></v-text-field>
    </template>
    <v-date-picker v-model="valueData" no-title scrollable :allowed-dates="getAllowedDate" @input="menu = false"></v-date-picker>
  </v-menu>
</template>
<script>
import store from '@/store'
import { Tool } from '@/util/index'
const tool = new Tool()
export default {
  name: 'arb-date-picker-menu',
  props: {
    value: {
      type: [String, Number]
    },
    label: {
      type: String,
      default: ''
    },
    allowed: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    lessDate: {
      type: [Number, String],
      default: null
    },
    moreDate: {
      type: [Number, String],
      default: null
    },
    numberDate: {
      type: [Boolean, String],
      default: false
    },
    notEmptyChanged: {
      type: [Boolean, String],
      default: false
    },
    holiday: {
      type: Array,
      default: () => store.getters.getHoliday
    },
    errorMessages: {
      type: String,
      default: ''
    },
    hideDetails: {
      type: [String, Boolean],
      default: 'auto'
    }
  },
  data () {
    return {
      valueData: typeof this.value === 'number' ? tool.formatDate(this.value) : this.value,
      menu: false
    }
  },
  watch: {
    value (val) {
      this.valueData = typeof val === 'number' ? tool.formatDate(val) : val
    },
    valueData (newVal, oldVal) {
      if (this.numberDate) { // for numberDate
        this.$emit('input', new Date(newVal).getTime())
        if (tool.isNotEmpty(oldVal)) {
          this.$emit('change', new Date(newVal).getTime())
        }
      } else if (this.notEmptyChanged) { // for notEmptyChange
        this.$emit('input', newVal)
        if (tool.isNotEmpty(oldVal)) {
          this.$emit('change', newVal)
        }
      } else { // for stringDate
        this.$emit('input', newVal)
        this.$emit('change', newVal)
      }
    }
  },
  computed: {
    eleRef () {
      return this.ref + this._uid
    }
  },
  methods: {
    getAllowedDate (val) {
      let result = true
      const time = new Date(val)

      if (this.allowed) {
        if (this.allowed.indexOf('start-now') !== -1) {
          result = result && (val >= tool.formatDate(new Date().getTime()))
        }

        if (this.allowed.indexOf('start-tomorrow') !== -1) {
          result = result && (val > tool.formatDate(new Date().getTime()))
        }

        if (this.allowed.indexOf('end-now') !== -1) {
          result = result && (val <= tool.formatDate(new Date().getTime()))
        }

        if (this.allowed.indexOf('in-one-year') !== -1) {
          result = result && (val <= tool.formatDate(this.getNMonthsAfter(12, new Date())))
        }
      }
      if (this.allowed.indexOf('no-weekend') !== -1) {
        result = result && (time.getUTCDay() !== 0 && time.getUTCDay() !== 6)
      }

      if (this.allowed.indexOf('no-holiday') !== -1) {
        result = result && (!this.holiday.includes(val))
      }

      if (this.lessDate) {
        result = result && (val <= (typeof this.lessDate === 'string' ? this.lessDate : tool.formatDate(this.lessDate)))
      }

      if (this.moreDate) {
        result = result && (val >= (typeof this.moreDate === 'string' ? this.moreDate : tool.formatDate(this.moreDate)))
      }
      return result
    },
    getNMonthsAfter (n, date) {
      const currentDate = tool.formatDate(date)
      const s = currentDate.split('-')
      const yy = parseInt(s[0])
      const mm = parseInt(s[1])
      const dd = parseInt(s[2])
      const dt = new Date(yy, mm + n - 1, dd)
      return dt.valueOf()
    }
  }
}
</script>
